<template>
	<header class="site-container__header">
		<div class="site-container__header__stripe">

		</div>
		<div class="site-container__header__nav container">
			<div class="row site-container__header__nav__top">
				<div class="col-3">
					<router-link to="/" class="site-container__header__logo">

					</router-link>
				</div>
				<div class="col-9 col-lg-12 header-nav" :class="{ 'open': nav_open }">
					<button @click.stop="nav_open = !nav_open" class="header-nav__trigger">
						<span class="burger"></span>
					</button>
					<nav class="header-nav__menu">
						<ul>
							<header-nav-link :key="'h-nav'+index" :nav="nav" v-for="(nav, index) in navFiltered"/>
						</ul>
					</nav>
				</div>
			</div>

		</div>
	</header>
</template>

<script>
	import NavLink from '@/components/layout/header-nav-link';
	export default {
		name: "Header",
		components:{
			'header-nav-link': NavLink
		},
		data(){
			return{

				nav_open: false
			}
		},
		computed:{
			navFiltered(){

				const nav = [
					{
						name: 'Home',
						path: '/',
						visibility: 'all'
					},
					{
						name: 'Stream',
						path: '/stream',
						visibility: 'w-auth',
						child: this.streams
					},
					{
						name: 'About',
						path: 'https://wettstar-pferdewetten.de/page/ueber_german_tote',
						visibility: 'all',
						blank: true
					},
					{
						name: 'Impressum',
						path: '/impressum',
						visibility: 'all',
					},
					{
						name: 'Login',
						path: '/login',
						visibility: 'wo-auth'
					},
					{
						name: 'Logout',
						path: '/logout',
						visibility: 'w-auth'
					},
				];

				return nav.filter((el)=>{
					return this.isVisible(el);
				})
			},
			streams(){
				let arr = [];
				if(this.user){

					this.user.channels.forEach((el)=>{
						arr.push({
							name: el.name,
							path: '/stream/'+el.id,
							visibility: 'all'
						});
					});

				}
				return arr;
			}
		},
		watch:{
			//global property
			/*user(value){
				this.navigation.forEach((el)=>{
					switch (el.visibility) {
						case 'all':
							break;
						case 'w-auth':
							break;
						case 'wo-auth':
							break;
					}
				})
			}*/
		},
		mounted(){

			document.querySelector('body').addEventListener('click', this.bodyClick);
		},
		beforeDestroy(){
			document.querySelector('body').removeEventListener('click', this.bodyClick);
		},
		methods:{
			isVisible(element){
				switch (element.visibility) {
					case 'all':
						return true;
					case 'w-auth':
						return !!this.user;
					case 'wo-auth':
						return !this.user;
				}
			},

			bodyClick(){

				this.nav_open = false;
			}
		}
	}
</script>

<style scoped>

</style>